export default __webpack_public_path__ + "static/media/sphab-favicon.bef854d7.ico";